import React from 'react'
import { Flex, Text, Tooltip } from '@workwhile/ui'
import { AmountRender } from 'pages/UserPayments/components/UserPaymentsRenderers/AmountRender'
import { InfoIcon } from 'lucide-react'

interface AlignedRowProps {
  label: string
  tooltip?: string
  value?: number
  labelProps?: any
  [key: string]: any
}

export const AmountEntry = ({
  label,
  tooltip,
  value,
  labelProps,
  ...props
}: AlignedRowProps) => {
  return (
    <Flex justifyContent="space-between" alignItems="center" {...props} my={1}>
      <Flex alignItems="center" gap={1}>
        <Text {...labelProps} fontSize={2}>
          {label}
        </Text>
        {tooltip ? (
          <Tooltip content={tooltip}>
            <InfoIcon size={16} />
          </Tooltip>
        ) : null}
      </Flex>
      <AmountRender value={value} props={{ fontSize: 2 }} />
    </Flex>
  )
}
